export const REQ_TYPE = {
  post: 'post',
  get: 'get',
  put: 'put',
  patch: 'patch',
  delete: 'delete',
}
